import { api } from '../../api.empty';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    listCustomSubscriptionConfigurations: build.query<
      ListCustomSubscriptionConfigurationsApiResponse,
      ListCustomSubscriptionConfigurationsApiArg
    >({
      query: () => ({ url: `/api/CustomSubscriptionConfigurations` }),
    }),
    createCustomSubscriptionConfiguration: build.mutation<
      CreateCustomSubscriptionConfigurationApiResponse,
      CreateCustomSubscriptionConfigurationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/CustomSubscriptionConfigurations`,
        method: 'POST',
        body: queryArg.createCustomSubscriptionConfigurationRequest,
      }),
    }),
    listAvailableCustomSubscriptionConfigurationNsbs: build.query<
      ListAvailableCustomSubscriptionConfigurationNsbsApiResponse,
      ListAvailableCustomSubscriptionConfigurationNsbsApiArg
    >({
      query: () => ({
        url: `/api/CustomSubscriptionConfigurations/ListAvailableNsbs`,
      }),
    }),
    getCustomSubscriptionConfiguration: build.query<
      GetCustomSubscriptionConfigurationApiResponse,
      GetCustomSubscriptionConfigurationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/CustomSubscriptionConfigurations/${queryArg.id}`,
      }),
    }),
    deleteCustomSubscriptionConfiguration: build.mutation<
      DeleteCustomSubscriptionConfigurationApiResponse,
      DeleteCustomSubscriptionConfigurationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/CustomSubscriptionConfigurations/${queryArg.id}`,
        method: 'DELETE',
      }),
    }),
    updateCustomSubscriptionConfigurationEntry: build.mutation<
      UpdateCustomSubscriptionConfigurationEntryApiResponse,
      UpdateCustomSubscriptionConfigurationEntryApiArg
    >({
      query: (queryArg) => ({
        url: `/api/CustomSubscriptionConfigurations/${queryArg.id}/entries/${queryArg.entryId}`,
        method: 'PUT',
        body: queryArg.updateCustomSubscriptionConfigurationEntryRequest,
      }),
    }),
    deleteCustomSubscriptionConfigurationEntry: build.mutation<
      DeleteCustomSubscriptionConfigurationEntryApiResponse,
      DeleteCustomSubscriptionConfigurationEntryApiArg
    >({
      query: (queryArg) => ({
        url: `/api/CustomSubscriptionConfigurations/${queryArg.id}/entries/${queryArg.entryId}`,
        method: 'DELETE',
      }),
    }),
    createCustomSubscriptionConfigurationEntry: build.mutation<
      CreateCustomSubscriptionConfigurationEntryApiResponse,
      CreateCustomSubscriptionConfigurationEntryApiArg
    >({
      query: (queryArg) => ({
        url: `/api/CustomSubscriptionConfigurations/${queryArg.configurationId}/entries`,
        method: 'POST',
        body: queryArg.createCustomSubscriptionConfigurationEntryRequest,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as customSubscriptionConfigurationsApi };
export type ListCustomSubscriptionConfigurationsApiResponse =
  /** status 200 Success */ CustomSubscriptionConfigurationDto[];
export type ListCustomSubscriptionConfigurationsApiArg = void;
export type CreateCustomSubscriptionConfigurationApiResponse =
  /** status 200 Success */ CustomSubscriptionConfigurationWithEntriesDto;
export type CreateCustomSubscriptionConfigurationApiArg = {
  createCustomSubscriptionConfigurationRequest: CreateCustomSubscriptionConfigurationRequest;
};
export type ListAvailableCustomSubscriptionConfigurationNsbsApiResponse =
  /** status 200 Success */ NsbDto[];
export type ListAvailableCustomSubscriptionConfigurationNsbsApiArg = void;
export type GetCustomSubscriptionConfigurationApiResponse =
  /** status 200 Success */ CustomSubscriptionConfigurationWithEntriesDto;
export type GetCustomSubscriptionConfigurationApiArg = {
  id: string;
};
export type DeleteCustomSubscriptionConfigurationApiResponse = unknown;
export type DeleteCustomSubscriptionConfigurationApiArg = {
  id: string;
};
export type UpdateCustomSubscriptionConfigurationEntryApiResponse =
  /** status 200 Success */ ConfigurationEntryDto;
export type UpdateCustomSubscriptionConfigurationEntryApiArg = {
  id: string;
  entryId: string;
  updateCustomSubscriptionConfigurationEntryRequest: UpdateCustomSubscriptionConfigurationEntryRequest;
};
export type DeleteCustomSubscriptionConfigurationEntryApiResponse = unknown;
export type DeleteCustomSubscriptionConfigurationEntryApiArg = {
  id: string;
  entryId: string;
};
export type CreateCustomSubscriptionConfigurationEntryApiResponse =
  /** status 200 Success */ ConfigurationEntryDto;
export type CreateCustomSubscriptionConfigurationEntryApiArg = {
  configurationId: string;
  createCustomSubscriptionConfigurationEntryRequest: CreateCustomSubscriptionConfigurationEntryRequest;
};
export type CustomSubscriptionConfigurationDto = {
  id: string;
  nsbRecId: number;
  nsbName: string;
};
export type ConfigurationEntryDto = {
  id: string;
  from: number;
  to: number;
  pricePerUnit: number;
  type: CustomSubscriptionConfigurationEntryType;
};
export type CustomSubscriptionConfigurationWithEntriesDto =
  CustomSubscriptionConfigurationDto & {
    sizeEntries: ConfigurationEntryDto[];
    userCountEntries: ConfigurationEntryDto[];
  };
export type SpError = {
  message?: string | null;
};
export type SpProblemDetails = {
  title?: string | null;
  status: number;
  detail?: string | null;
  instance?: string | null;
  traceId?: string | null;
  errors?: SpError[] | null;
};
export type CreateCustomSubscriptionConfigurationRequest = {
  nsbRecId: number;
};
export type NsbDto = {
  id: number;
  nsbId: string;
};
export type UpdateCustomSubscriptionConfigurationEntryRequest = {
  from: number;
  to: number;
  pricePerUnit: number;
};
export type CreateCustomSubscriptionConfigurationEntryRequest = {
  from: number;
  to: number;
  pricePerUnit: number;
  type: CustomSubscriptionConfigurationEntryType;
};
export enum CustomSubscriptionConfigurationEntryType {
  Size = 'Size',
  UserCount = 'UserCount',
}
export const {
  useListCustomSubscriptionConfigurationsQuery,
  useLazyListCustomSubscriptionConfigurationsQuery,
  useCreateCustomSubscriptionConfigurationMutation,
  useListAvailableCustomSubscriptionConfigurationNsbsQuery,
  useLazyListAvailableCustomSubscriptionConfigurationNsbsQuery,
  useGetCustomSubscriptionConfigurationQuery,
  useLazyGetCustomSubscriptionConfigurationQuery,
  useDeleteCustomSubscriptionConfigurationMutation,
  useUpdateCustomSubscriptionConfigurationEntryMutation,
  useDeleteCustomSubscriptionConfigurationEntryMutation,
  useCreateCustomSubscriptionConfigurationEntryMutation,
} = injectedRtkApi;
